import $t from '../../../i18n'

import './SelectedPlanInfo.css'

const SelectedPlanInfo = ({ planName, monthlyPremium, effectiveDate }) => {
  return (
    <div className='selected-plan-info'>
      <div className='plan-field'>
        <div className='plan-field-label semi-bold'>
          {$t('enroll.plans.plan.selectedPlan')}:
        </div>
        <div className='plan-field-value'>{planName}</div>
      </div>
      <div className='row plan-fields'>
        <div className='plan-field'>
          <div className='plan-field-label semi-bold'>
            {$t('enroll.plans.plan.monthlyPremium')}:
          </div>
          <div className='plan-field-value'>{monthlyPremium}</div>
        </div>
        <div className='plan-field'>
          <div className='plan-field-label semi-bold'>
            {$t('fields.coverageDate')}:
          </div>
          <div className='plan-field-value'>{effectiveDate}</div>
        </div>
      </div>
    </div>
  )
}

export default SelectedPlanInfo
